"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Mh = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 57 30", ...props },
    react_1.default.createElement("path", { fill: "#003087", d: "M0 0h57v30H0z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M0 29.52v-.72L57 3.5v8.74z" }),
    react_1.default.createElement("path", { fill: "#E57200", d: "M0 29.04v-.48L57 .48v5.88z" }),
    react_1.default.createElement("g", { fill: "#fff", transform: "translate(10.954 10.954)" },
        react_1.default.createElement("g", { id: "mh_svg__b" },
            react_1.default.createElement("path", { d: "M0-9.3.559 0H-.559z" }),
            react_1.default.createElement("path", { id: "mh_svg__a", d: "M0-6.659.682 0H-.682z", transform: "rotate(15)" }),
            react_1.default.createElement("use", { xlinkHref: "#mh_svg__a", transform: "rotate(15)" }),
            react_1.default.createElement("use", { xlinkHref: "#mh_svg__a", transform: "rotate(30)" }),
            react_1.default.createElement("use", { xlinkHref: "#mh_svg__a", transform: "rotate(45)" }),
            react_1.default.createElement("use", { xlinkHref: "#mh_svg__a", transform: "rotate(60)" })),
        react_1.default.createElement("use", { xlinkHref: "#mh_svg__b", transform: "rotate(90)" }),
        react_1.default.createElement("use", { xlinkHref: "#mh_svg__b", transform: "rotate(180)" }),
        react_1.default.createElement("use", { xlinkHref: "#mh_svg__b", transform: "rotate(270)" }))));
exports.default = Mh;
//# sourceMappingURL=Mh.js.map